import React from "react";

/* ── Design tokens (importar PRIMERO) ── */
import "./css/xAgro.tokens.css";

/* ── Estilos compartidos ── */
import "./css/Styles.css";
import "./css/Home.css";
import "./css/Features.css";
import "./css/xAgro.css";

/* ── Componentes ── */
import HomeBackground from "./components/xAgro/HomeBackground";
import FeaturesPlatform from "./components/xAgro/FeaturesPlatform";
import Resume from "./components/xAgro/Resume";
import Network from "./components/xAgro/Network";
import Software from "./components/xAgro/Software";
import FooterSection from "./components/xAgro/FooterSection";
import ContactSection from "../ContactSection/Contact";
import DigitalTools from "./components/xAgro/DigitalTools";
import { withTranslation } from "react-i18next";
import Stations from "./components/xAgro/Stations";
import XAdvisor from "./components/xAgro/XAdvisor";
import XAir from './components/xAgro/XAir';

const data = `xAgro`;

const xAgro = () => {
  return (
    <div className="spiderProduct-Screen main" id="spiderMonitor">
      <HomeBackground data={`${data}.home`} />
      <FeaturesPlatform data={`${data}.features-app`} />
      <Resume data={`${data}.resume`} />
      <Network data={`${data}.network`} />
      <Software data={`${data}.software`} />
      <DigitalTools
        reverse={true}
        data={`${data}.tools`}
        id={"xAgroTools"}
      />
      <XAdvisor data={`${data}.advisor`} />
      <Stations data={`${data}.stations`} />
      <XAir data={`${data}.air`} />
      <FooterSection />
      <ContactSection color={"#17222f"} />
    </div>
  );
};

export default withTranslation("common")(xAgro);